import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { showPopupNew } from '../../actions/popup-actions';
import { PopupTypes } from '../../utils/constants';

export const SUBSCRIPTIONS_PATH = '/subscriptions';
export const RESUME_POWER_LABEL = 'Resume Power';
export const DEFAULT_POWER_CTA_LABEL = 'Get Power';

const useStartPowerCheckout = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const hasPastDueSubscription = useSelector(
        ({ auth }) => !!auth?.user?.hasPastDueSubscription,
    );

    const startPowerCheckout = ({
        surface,
        gatedFeature,
        prismicTitle,
        onContinue,
        confirmResume = false,
        plansOffered,
        showHotelPlannerCard,
    } = {}) => {
        if (hasPastDueSubscription) {
            if (confirmResume) {
                dispatch(showPopupNew({ popup: PopupTypes.POWER_RESUME_CONFIRM_POPUP }));
                return 'past_due_confirm';
            }
            history.push(SUBSCRIPTIONS_PATH);
            return 'past_due_redirect';
        }
        if (onContinue) {
            onContinue();
            return 'custom_continue';
        }
        dispatch(showPopupNew({
            popup: PopupTypes.POWER_UPGRADE_POPUP,
            referringSurface: surface,
            gatedFeature,
            prismicTitle,
            plansOffered,
            showHotelPlannerCard,
        }));
        return 'popup';
    };

    const ctaLabel = (defaultText = DEFAULT_POWER_CTA_LABEL) => (
        hasPastDueSubscription ? RESUME_POWER_LABEL : defaultText
    );

    return { hasPastDueSubscription, startPowerCheckout, ctaLabel };
};

export default useStartPowerCheckout;
